// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_js":"c9314858ad251e23","node_modules_canvg_lib_index_es_js":"e1e0246b7c734280"}[chunkId] + ".js";
};